import { get } from "lodash-es";
import { useLocation } from "react-router-dom";

import { PATH } from "../../router/path";

const headerConfig = {
	"/": {
		hideBack: false,
		hideLanguageSelect: false,
	},
	[PATH.PRODUCT_LIST]: {
		hideBack: true,
		hideLanguageSelect: false,
	},
	[PATH.PRODUCT_DETAIL]: {
		hideLanguageSelect: true,
	},
	[PATH.ORDER_CONFIRMATION]: {
		hideHeader: true,
		hideBack: true,
		hideLanguageSelect: true,
	},
};

const useHeaderConfig = (): {
	hideBack: boolean;
	hideLanguageSelect: boolean;
	hideHeader: boolean;
} => {
	const location = useLocation();

	return get(headerConfig, location.pathname, {
		hideBack: false,
		hideLanguageSelect: false,
		hideHeader: false,
	});
};

export default useHeaderConfig;
